/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-expressions */
export default ({ app }, inject) => {
    let pixelInitialized = false

    // Local queue until real fbq is ready
    const callQueue = []

    const fbqProxy = (...args) => {
        if (typeof window.fbq === 'function') {
            window.fbq(...args)
        } else {
            callQueue.push(args)
        }
    }

    inject('fbq', fbqProxy)

    const initFacebookPixel = (pixelId) => {
        if (process.server) return
        if (!pixelId) return
        if (pixelInitialized) return

        // Load FB Pixel script
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments)
            }
            if (!f._fbq) f._fbq = n
            n.push = n
            n.loaded = !0
            n.version = '2.0'
            n.queue = []
            t = b.createElement(e)
            t.async = !0
            t.src = v
            s = b.getElementsByTagName(e)[0]
            s.parentNode.insertBefore(t, s)
        })(
            window,
            document,
            'script',
            'https://connect.facebook.net/en_US/fbevents.js'
        )

        window.fbq('init', pixelId)
        // window.fbq('track', 'PageView') // <-- important to trigger cookies

        // Flush queued calls
        callQueue.forEach((args) => window.fbq(...args))
        callQueue.length = 0

        pixelInitialized = true

        app.$fbq = window.fbq
    }

    inject('initFbPixel', initFacebookPixel)
}

/**
 * Usage: mounted() this.$initFbPixel(1407417937037280)
 * To track: this.$fbq('track', 'HelloWorld', { foo: 'bar' })
 */
